var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisableAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 6.66732H11.1673V5.00065C11.1673 2.70065 9.30065 0.833984 7.00065 0.833984C4.70065 0.833984 2.83398 2.70065 2.83398 5.00065V6.66732H2.00065C1.08398 6.66732 0.333984 7.41732 0.333984 8.33398V16.6673C0.333984 17.584 1.08398 18.334 2.00065 18.334H8.04623C7.38716 17.3891 7.00065 16.24 7.00065 15.0006C7.00065 11.779 9.61232 9.16732 12.834 9.16732C13.1169 9.16732 13.3951 9.18746 13.6673 9.22639V8.33398C13.6673 7.41732 12.9173 6.66732 12.0007 6.66732ZM9.58398 6.66732V5.00065C9.58398 3.57565 8.42565 2.41732 7.00065 2.41732C5.57565 2.41732 4.41732 3.57565 4.41732 5.00065V6.66732H9.58398Z",
    fill: "#D32F2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66732 14.999C8.66732 12.6957 10.5291 10.834 12.8323 10.834C15.1356 10.834 16.9973 12.6957 16.9973 14.999C16.9973 17.3022 15.1356 19.164 12.8323 19.164C10.5291 19.164 8.66732 17.3022 8.66732 14.999ZM12.8323 14.4117L13.9111 13.333L14.4983 13.9202L13.4196 14.999L14.4983 16.0777L13.9111 16.665L12.8323 15.5863L11.7536 16.665L11.1663 16.0777L12.2451 14.999L11.1663 13.9202L11.7536 13.333L12.8323 14.4117Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableAccess);
export default __webpack_public_path__ + "static/media/disableAccess.d98ca7e5f93252e06dd37c1a5d01f96c.svg";
export { ForwardRef as ReactComponent };